import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import i18n from "i18next";
import RaisedButton from 'material-ui/RaisedButton';
import {connect} from "react-redux";
import styles from '../../../styles/styles';
import { renderCheckbox, renderSelectField, renderTextField } from '../../../services/form';
import withTranslation from '../../../hoc/withTranslation';
import { RICHTEXT, TEXT } from '../../../constants/customfiled';
import MenuItem from 'material-ui/MenuItem';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'name'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });

    return errors;
};

export class CustomFieldForm extends React.Component {

    static propTypes = {
        onFormReset: PropTypes.func,
        entityName: PropTypes.string
    };

    // Render

    render() {
        const {handleSubmit, pristine, reset, submitting} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    {this.props.entityName &&
                    <Field
                        id="entity_name"
                        name="entity_name"
                        component="hidden"
                    />
                    }
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t("generic.name")}
                        fullWidth={true}
                    />
                    <Field
                        id="type"
                        name="type"
                        component={renderSelectField}
                        label={this.props.t("generic.type")}
                        fullWidth={true}
                    >
                        <MenuItem key={TEXT} value={TEXT} primaryText={this.props.t("generic.custom_field." + TEXT)}></MenuItem>
                        <MenuItem key={RICHTEXT} value={RICHTEXT} primaryText={this.props.t("generic.custom_field." + RICHTEXT)}></MenuItem>
                    </Field>
                    <Field
                        id="tag"
                        name="tag"
                        component={renderTextField}
                        label="Tag"
                        fullWidth={true}
                    />
                    <Field
                        id="visible"
                        name="visible"
                        component={renderCheckbox}
                        label="Visible"
                    />
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

CustomFieldForm = reduxForm({
    form: 'editCustomField',
    validate
})(CustomFieldForm);

function mapStateToProps(state, ownProps) {
    let props = {...ownProps};

    if (ownProps.entityName) {
        if (ownProps.initialValues) {
            props.initialValues.entity_name = ownProps.entityName
        } else {
            props.initialValues = {
                entity_name: ownProps.entityName
            }
        }
    }

    return props;
}

export default connect(mapStateToProps, {})(withTranslation(CustomFieldForm));




// WEBPACK FOOTER //
// src/components/customfield/CustomFieldForm/CustomFieldForm.js